import http from 'lib/http';


export const urlgetVoteInfo = '/api/XOrg/CourseSectionIndex/getVoteInfo';

export interface IMsg {
  code: number;
  msg: string;
}

export interface IChapterList {
  code: number;
  msg: string;
  list: {
    Id: string;
    SectionName: string;
    ChapterId: string;
    ChapterName: string;
  }[];
}



export interface IChapterSection {
  code: number;
  msg: string;
}


export interface ISourceList {
  code: number;
  msg: string;
  tasklist: {
    Id: string;
    PaperName: string;
    CreateDisplayName: string;
  }[];
  pagination: {
    pageIndex: string;
    pageSize: string;
    totalCount: string;
  };
}



export interface ICourseWare {
  code: number;
  msg: string;
  coursewarelist: {
    Id: string;
    FolderId: string;
    CourseWareName: string;
    NodePath: string
  }[];
}


export interface ICourseTeach {
  code: number;
  msg: string;
  deslist: {
    TeacherName: string;
    Title: string;
    Cover: string;
    Description: string;
    TeaDes: string;
    CoverUrl: string;
    Jobs: string;
  }[];
}

export interface ITeachTeam {
  code: number;
  msg: string;
  tealist: {
    Id: string;
    UserId: string;
    UserName: string;
    TeacherName: string;
    CoverUrl: string;
    Jobs: string;
    Mobile: string;
    CreateUserId: string;
    CreateUserName: string;
    CreateDisplayName: string;
  }[];
}




export interface Iinfo {
  code: number;
  info: {
    SectionName: string;
    Content: string;
  };
}


export interface Iactivitylist {
  code: number;
  msg: string;
  actlist: {
    Id: string;
    activityname: string;
    activitytype: string;
  }[];
  pagination: {
    pageIndex: string;
    pageSize: string;
    totalCount: string;
  };
}


export interface IVoteInfo {
  code: number;
  msg: string;
  voteInfo: {
    ActivityName: string;
    ActivityContent: string;
    DocJson: string;
    VoteType: number;
    DataJson: string;
  }[];
}

export function getVoteInfo(Id: string) {
  return http.post<IVoteInfo>(urlgetVoteInfo, {
    Id
  });
}